import React, { Component, PropsWithChildren, ReactElement } from 'react';
import { INavProps, Nav, NavItem } from '../Nav';
import { ITabProps } from './types';

export class Tabs extends Component<PropsWithChildren<INavProps>, {}> {
  // returns true when tab is active
  public isActive(tab: ReactElement<ITabProps>) {
    const { activeKey } = this.props;
    return activeKey && tab.props.eventKey === activeKey ? true : false;
  }

  // returns a <NavItem> for this tab
  public buildNavItem(tab: ReactElement<ITabProps>) {
    const { disabled, eventKey, label, tooltip } = tab.props;
    return (
      <NavItem key={eventKey} role={'tab'} disabled={disabled} eventKey={eventKey} tooltip={tooltip}>
        {label || eventKey.toString()}
      </NavItem>
    );
  }

  public handleSelect = (key: any) => {
    const { onSelect } = this.props;
    onSelect && onSelect(key);
  };

  public render() {
    const { onSelect, role, bsStyle = 'pills', ...props } = this.props;

    return (
      <div className={'hlc-tabs'} qa-id={this.props['qa-id']}>
        <Nav role={'tablist'} onSelect={this.handleSelect} bsStyle={bsStyle} {...props}>
          {React.Children.toArray(this.props.children)
            .filter((child) => !!child)
            .map((child) => this.buildNavItem(child as ReactElement<ITabProps>))}
        </Nav>
        <div className="tab-content">{this.renderActiveTab()}</div>
      </div>
    );
  }

  private renderActiveTab() {
    const { activeKey } = this.props;
    const activeChild = React.Children.toArray(this.props.children).find(
      (child: any) => child.props.eventKey === activeKey,
    );
    const ActiveTab = activeChild
      ? React.cloneElement(activeChild as ReactElement<ITabProps>, {
          active: true,
        })
      : null;
    return ActiveTab;
  }
}

export default Tabs;
